import Footer from './Footer';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ConditionalFooter = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Pages where footer should be hidden
  const hideFooterPages = ['/login', '/register', '/forgot-password'];
  const isHiddenPage = hideFooterPages.some(page => location.pathname.startsWith(page));

  // Only show footer on logged out pages and not on login/register
  if (isAuthenticated || isHiddenPage) {
    return null;
  }

  return <Footer />;
};

export default ConditionalFooter;
